import { STEP_ORDER, type StepKey } from '../state/ProgressContext';

export const PROGRESS_ROUTES: Record<StepKey, string> = {
  LOCATION: '/onboarding/country',
  INITIAL_NOTICE: '/onboarding/notice',
  APPLICATION_QUESTIONS: '/onboarding/application',
  APPLICATION_REVIEW: '/onboarding/application',
  SALES_RESOURCES: '/onboarding/resources',
  AGREEMENT: '/onboarding/agreement',
  TAX_FORM: '/onboarding/tax-form',
  DOCUMENT_REVIEW: '/onboarding/document-review',
  ONBOARDING_WELCOME: '/onboarding/training',
  GET_LEADS: '/onboarding/training',
  PREPARE: '/onboarding/training',
  MAKE_THE_CALL: '/onboarding/training',
  FOLLOW_UP: '/onboarding/training',
  COMPLETE: '/onboarding/training',
};

export function routeForCurrentProgress(currentStep: StepKey) {
  return PROGRESS_ROUTES[currentStep] ?? '/onboarding/country';
}

export function routeForFurthestProgress(progress: { currentStep: StepKey; highestUnlockedStepIndex: number }) {
  const furthest = STEP_ORDER[Math.min(Math.max(progress.highestUnlockedStepIndex, 0), STEP_ORDER.length - 1)] ?? progress.currentStep;
  return routeForCurrentProgress(furthest);
}
